const { InspectorControls } = wp.blockEditor;
const { PanelBody, ToggleControl, SelectControl } = wp.components;
import SelectMargin from '../../wp-controlers/select-margin';
import SelectColor from '../../wp-controlers/select-color';
import SelectAlign from '../../wp-controlers/select-align';
import SelectMaxWidth from '../../wp-controlers/select-max-width';

const Inspector = ({ attributes, setAttributes }) => {
  const { containerized, removeMarker, fontWeight } = attributes;

  return (
    <InspectorControls>
      <PanelBody>
        <ToggleControl
          label="Este titulo está fora de um container?"
          checked={containerized}
          onChange={() => setAttributes({ containerized: !containerized })}
        />

        <SelectControl
          label="Selecione o peso da fonte"
          title="Selecione o peso da fonte"
          value={fontWeight}
          options={[
            { label: 'Padrão (400)', value: 'fw-400' },
            { label: '500', value: 'fw-500' },
          ]}
          onChange={(position) => setAttributes({ fontWeight: position })}
        />

        <SelectColor attributes={attributes} setAttributes={setAttributes} />
        <SelectAlign attributes={attributes} setAttributes={setAttributes} />
        <SelectMargin attributes={attributes} setAttributes={setAttributes} />
        <SelectMaxWidth attributes={attributes} setAttributes={setAttributes} />
      </PanelBody>

      <PanelBody title="Configurações de tópicos" initialOpen={false}>
        <ToggleControl
          label="Remover marcadores dos tópicos"
          checked={removeMarker}
          onChange={() => setAttributes({ removeMarker: !removeMarker })}
        />
      </PanelBody>
    </InspectorControls>
  );
};

export default Inspector;
